"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StitchCollectionServer_1 = __importDefault(require("./StitchCollectionServer"));

var StitchDatabaseServer =
/** @class */
function () {
  function StitchDatabaseServer(db) {
    this.db = db;
    this.name = this.db.name;
  }

  StitchDatabaseServer.prototype.collection = function (name) {
    return new StitchCollectionServer_1.default(this.db.collection(name));
  };

  return StitchDatabaseServer;
}();

exports.default = StitchDatabaseServer;